export const DEFAULT_NS = 'translation';
